export { default } from "./reducer";



// WEBPACK FOOTER //
// ./src/model/subsystems/app/reducer/index.js